const SkeletonLoader = () => {
  return (
    <div className="relative z-10 animate-pulse">
      {/* Symptoms Section Skeleton */}
      <div className="p-4 bg-white rounded-lg mx-4 mt-4 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-5 h-5 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-24"></div>
        </div>

        {[1, 2, 3].map((index) => (
          <div key={index} className="ml-3 relative pl-4 mb-6">
            <div className="absolute left-0 top-[10px] w-1.5 h-1.5 bg-gray-200 rounded-full"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-3/4"></div>
          </div>
        ))}
      </div>

      {/* Medical History Section Skeleton */}
      <div className="p-4 bg-white rounded-lg mx-4 mt-4 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-5 h-5 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded w-24"></div>
        </div>

        {[1, 2, 3].map((index) => (
          <div key={index} className="ml-3 relative pl-4 mb-6">
            <div className="absolute left-0 top-[10px] w-1.5 h-1.5 bg-gray-200 rounded-full"></div>
            <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
            <div className="h-3 bg-gray-200 rounded w-3/4"></div>
          </div>
        ))}
      </div>

      {/* Notes Section Skeleton */}
      <div className="p-4 bg-white rounded-lg mx-4 mt-4 shadow-sm" />
    </div>
  );
};

export default SkeletonLoader;
